export const Health = ({ onChange, data }) => {
  return (
    <div className="content-form">
      <div className="row">
        <div className="col">
          <h3>Informaciones de Salud</h3>
        </div>
      </div>
      <div className="row">
        <div className="col-2">
          <div className="label">PCD</div>
          <div className="radio-group" onChange={onChange}>
            <div>
              <input type="radio" onChange={() => {}} value={true} name="pcdResp" id="Yes" checked={String(data.pcdResp) === 'true'} />
              <label htmlFor="Yes">Si</label>
            </div>
            <div>
              <input type="radio" onChange={() => {}} value={false} name="pcdResp" id="No" checked={String(data.pcdResp) === 'false'} />
              <label htmlFor="No">No</label>
            </div>
          </div>
        </div>
        <div className="col">
          <label htmlFor="person_with_disability" style={{ color: !JSON.parse(data.pcdResp)? '#d9d9e2' : '#444258' }} >Tipo</label>
          <input type="text" id="special_needs" name="person_with_disability" onChange={onChange} value={JSON.parse(data.pcdResp) ? data.person_with_disability : ''} disabled={!JSON.parse(data.pcdResp)} />
        </div>
      </div>
    </div>
  );
};
